import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';

// startDate/endDate: วันที่ตั้งแต่-ถึง (ปีที่เลือกไม่มีผล ระบบเทียบแค่วัน-เดือนซ้ำทุกปี)
// endDate/setEndDate ไม่ส่งมา (undefined) → โชว์แค่ช่องเดียว (ใช้หน้าแก้ไขทีละวัน)
export default function HolidayForm({
  errors,
  holiday,
  Controller,
  control,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) {
  const isRange = setEndDate !== undefined;
  return (
    <div className="">
      <div className="w-full px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={holiday ? holiday.name : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="name"
              required
              fullWidth
              size={'small'}
              helperText={errors.name && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className={isRange ? 'w-full px-1 py-2 flex flex-row gap-2' : 'w-full px-1 py-2'}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={isRange ? 'วันที่เริ่ม' : 'วันที่'}
            value={startDate}
            fullWidth
            onChange={(newDate) => setStartDate(newDate)}
            renderInput={(params) => <TextField fullWidth {...params} />}
          />
          {isRange && (
            <DatePicker
              label="ถึงวันที่"
              value={endDate}
              minDate={startDate}
              fullWidth
              onChange={(newDate) => setEndDate(newDate)}
              renderInput={(params) => <TextField fullWidth {...params} />}
            />
          )}
        </LocalizationProvider>
      </div>
      {isRange && (
        <div className="w-full px-1 text-xs text-gray-400">
          ไม่ต้องสนใจปีที่เลือก — ระบบจะถือว่าวันหยุดนี้เกิดซ้ำทุกปีตามวัน/เดือนที่เลือก
          {' '}(ถ้ามีหลายวันติดกัน จะสร้างเป็นวันหยุดแยกทีละวันให้อัตโนมัติ)
        </div>
      )}
    </div>
  );
}
